<template>
  <div>
    <div
      :class="{
        'flex gap-2 w-full content-center px-2': true,
        'flex-row-reverse justify-end': checkLeft,
      }"
    >
      <label v-if="label" :for="id" class="body-md self-center">
        {{ label }}
        <span v-if="required" class="text-error">{{ required ? '*' : '' }}</span>
      </label>
      <input
        :id="id"
        v-bind="$attrs"
        v-model="checked"
        :name="id"
        type="checkbox"
        class="shrink-0 w-[18px] h-[18px] p-[6px] border-2 border-outline rounded-[4px] bg-white/50"
      />
    </div>
    <div v-if="error" class="d-block mx-2">
      <small class="text-error">{{ error.charAt(0).toUpperCase() + error.slice(1) }}</small>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'CheckInput',
  props: {
    id: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: { type: [Boolean, String, Number], default: false },
    label: String,
    error: String,
    checkLeft: { type: Boolean, default: false },
  },
  data() {
    return { checked: this.value }
  },
  watch: {
    checked() {
      this.$emit('input', this.checked)
    },
    value() {
      this.checked = this.value
    },
  },
}
</script>
